import styled from 'styled-components';

const MembersBody = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
`;

export default MembersBody;
